import { InferenceResultSubdiv } from './InferenceResultSubdiv';
import { InferenceAdditionalResultSubdiv } from './InferenceAdditionalResultSubdiv';
import { KansatsuKirokuObsrec } from './KansatsuKirokuObsrec';

/**
 * 観察簿データ
 */
export class KansatsuKirokuSubdiv {
  koujiBangou: string;
  key: string;
  kansatsuDate: string; // 観察年月日(YYYY-MM-DD)
  sokutenNumber: string; // 測点No
  danmenNumber: string; // 断面番号
  kyori: string; // 坑口からの距離
  kansatsuDateMemo: string; // 観察年月日(YYYY-MM-DD)
  sokutenNumberMemo: string; // 測点No
  danmenNumberMemo: string; // 断面番号
  kyoriMemo: string; // 坑口からの距離
  inferenceResultSubdivJsonStr: string; // 推論結果のJSONの文字列表現
  inferenceAdditionalResultSubdivJsonStr: string; // 推論結果追加情報のJSONの文字列表現
  inferenceResultSubdiv: InferenceResultSubdiv[];
  inferenceAdditionalResultSubdiv: InferenceAdditionalResultSubdiv;
  observationsScores: KansatsuKirokuObsrec['observationsScores'];
  observationsScoresOrg: KansatsuKirokuObsrec['observationsScores'];
  observationsScoresJsonStr: string; // 人判断の評価結果
  observationsScoresOrgJsonStr: string; // 人判断の評価結果
  inferenceAdditionalResultHumanSubdivJsonStr: string; // 推論結果追加情報のJSONの文字列表現
  // nferenceAdditionalResultHumanSubdiv: InferenceAdditionalResultSubdiv; // 画面で生成するので不要 人判断の評価結果 推論結果追加情報のJSONの文字列表現
  inferenceId: string;
  croppedImageBucket: string; // 切り抜き済み画像格納Bucket
  croppedImageKey: string; // 切り抜き済み画像格納key
  originalImageBucket: string; // オリジナル画像格納Bucket
  originalImageKey: string; // オリジナル画像格納key
  croppedImageSignedUrl: string;
  // 自由入力欄
  freeInputs: Array<{
    title: string;
    value: string;
    memo: string;
  }>
  freeInputsJsonStr: string;
  createdAt: string; // 作成日時
  lastModifiedAt: string; // 最終更新日時
  deletedAt: string; // 削除日時
  downloadFileStatus: string;
  downloadFileBucket: string;
  downloadFileKey: string;
  downloadFileCreationDatetime: string; // ダウンロードファイルの作成日時 YYYY-MM-DDThh:mm:ss+0900
  downloadFileUrl: string; // ダウンロードファイルのSignedURL
  rockMassGroup?: string; // 岩盤グループ (Optional)
}



// WEBPACK FOOTER //
// ./src/models/KansatsuKirokuSubdiv.ts